import type { ComponentProps } from "react"

import { Badge } from "@/components/ui/badge"
import { Skeleton } from "@/components/ui/skeleton"
import type { PitchStatus } from "@/shared/types"

export type PitchStatusBadgeStatus = PitchStatus | "ineligible"

const STATUS_LABEL: Record<PitchStatusBadgeStatus, string> = {
  pitched: "Pitched",
  "needs-info": "Needs info",
  approved: "Accepted",
  rejected: "Rejected",
  withdrawn: "Withdrawn",
  ineligible: "Ineligible",
}

const STATUS_VARIANT: Record<
  PitchStatusBadgeStatus,
  ComponentProps<typeof Badge>["variant"]
> = {
  pitched: "default",
  "needs-info": "warning",
  approved: "success",
  rejected: "destructive",
  withdrawn: "secondary",
  ineligible: "warning",
}

export type PitchStatusBadgeProps = {
  status: PitchStatusBadgeStatus
  className?: string
}

export function PitchStatusBadge({ status, className }: PitchStatusBadgeProps) {
  return (
    <Badge variant={STATUS_VARIANT[status]} className={className}>
      {STATUS_LABEL[status]}
    </Badge>
  )
}

export function PitchStatusBadgeSkeleton({ className }: { className?: string }) {
  return <Skeleton className={className ?? "h-6 w-16 rounded-full"} />
}
